export default __webpack_public_path__ + "static/media/nav-account-red.47356336.svg";